<script setup>
import {ref} from 'vue'
const show = ref(false);

const open = () => {
  show.value = !show.value;
}

defineExpose({open})
</script>

<template>
  <div class="contact_us" v-if="show" @click="">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.contact_us {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>